import type { ReportDefinitionSchedule, ReportScheduleUnit } from './api';
import { ReportSchedule } from './report-schedule';

/**
 * O horário de um relatório enquanto se edita. Os dias da semana e os do mês ficam guardados cada um
 * no seu, para trocar a unidade e voltar sem perder o que já se marcou.
 */
export class ReportScheduleDraft {
  private static readonly NEXT_SENDS = 3;

  interval = $state(1);
  unit = $state<ReportScheduleUnit>('month');
  weekdays = $state<number[]>([]);
  monthDays = $state<number[]>([]);
  startsOn = $state('');
  sendTime = $state('');

  readonly schedule = $derived(new ReportSchedule(this.toSchedule()));
  readonly nextSends = $derived(this.schedule.nextSends({ count: ReportScheduleDraft.NEXT_SENDS, from: new Date() }));

  constructor(initial: ReportDefinitionSchedule) {
    this.interval = initial.interval;
    this.unit = initial.unit;
    if (initial.unit === 'week') this.weekdays = [...initial.days];
    if (initial.unit === 'month') this.monthDays = [...initial.days];
    this.startsOn = initial.startsOn;
    this.sendTime = initial.sendTime;
  }

  get isComplete(): boolean {
    return this.interval >= 1 && !this.schedule.isMissingDays() && !!this.startsOn && !!this.sendTime;
  }

  toSchedule(): ReportDefinitionSchedule {
    const days: Record<ReportScheduleUnit, number[]> = { hour: [], day: [], week: this.weekdays, month: this.monthDays };
    return {
      interval: this.interval,
      unit: this.unit,
      days: [...days[this.unit]].sort((first, second) => first - second),
      startsOn: this.startsOn,
      sendTime: this.sendTime,
    };
  }
}
